import React from 'react';

const CompFmtTextarea = ({ attrs, onChange, onBlur }) => {
    const {
        id,
        label,
        type = 'text',
        placeholder = '',
        required = '',
        maxLength,
        value = '',
        height = '150px',
        disabled = false,
        classCol = 'col-12',
        className = 'form-control'
    } = attrs;

    return (
        <div className={classCol}>
            <label htmlFor={id} className="form-label">
                {label}
            </label>
                <div className="input-group has-validation" style={{ height: height}}>
                    {required ? (<span className="input-group-text">*</span>) : (<></>)}
                    <textarea 
                        type={type}
                        className={className}
                        id={id}
                        placeholder={placeholder}
                        required={required}
                        maxLength={maxLength}
                        disabled={disabled}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                    {required ? (<div className="invalid-feedback"></div>) : (<></>)}
                </div>
        </div>
    );
};

export default CompFmtTextarea;